// src/pages/home/MainLoggedIn.jsx
import React from "react";
import NavbarLoggedIn from "../../components/LoggedIn/NavbarLoggedIn"; // Importamos el componente NavbarLoggedIn
import Dashboard from "../../components/LoggedIn/Dashboard"; // Importamos el componente Dashboard

export default function MainLoggedIn() {
  return (
    
      <>
        <NavbarLoggedIn /> 
        <Dashboard />
      </>
  );
}
